/**
 * Moderation Topic Detail Header Section
 *
 * Displays PageHeader with topic information
 */

import type { ModerationCommunity } from '@moderation/domain/ModerationCommunity';
import { PageHeader } from '@soteria/design-system-ve';

interface ModerationTopic {
  id: string;
  name: string;
  description: string;
}

interface ModerationTopicDetailHeaderSectionProps {
  community: ModerationCommunity | null;
  topic: ModerationTopic | null;
  isLoading: boolean;
}

export function ModerationTopicDetailHeaderSection({ community: _community, topic, isLoading }: ModerationTopicDetailHeaderSectionProps) {
  if (isLoading || !topic) {
    return <PageHeader isLoading title="" />;
  }

  return <PageHeader data-testid="moderation-topic-header-v2" subtitle={topic.description} title={topic.name} />;
}
